import React from 'react';
// import UserNav from './userNav';
// import UserConnect from './userConnect';

import { useParams, NavLink } from "react-router-dom";
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux"
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';
import { USER_INIT } from '../constants/globals.js';
import { updateUserPW } from '../actions/actions-types.js';

const UserViewPW = (props) => {

    const { userCJ } = useSelector(state => state);
    const dispatch = useDispatch();

    const { postId } = useParams();
    const [userFiche, setUserFiche] = useState([]);
    const [userPass, setUserPass] = useState({ verifPass: "", verifPass2: "" });
    const [userSave, setUserSave] = useState({ saved: false });
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);

    let userN = 0;
    if (typeof (postId) === "undefined" || userCJ.uAdmin === 0 || userCJ.uNum < 1) { userN = userCJ.uNum } else { userN = postId };
    useEffect(() => {
        if (userN === 0) {
            setUserFiche(USER_INIT);
        } else {
            fetch(`${URL_COURTJUS_BACK}/users/${userN}`, {
                method: 'GET',
                headers: headers,
            })
                .then(response => response.json())
                .then(res => {
                    if (res === null) {
                        setUserFiche(USER_INIT);
                    } else {
                        setUserFiche(res[0]);
                    }
                });
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setUserPass({ verifPass: "", verifPass2: "" });
    }
        , []);


    let adminSecu = true;
    if (userCJ.uAdmin !== 0) { adminSecu = false };
    let persoSecu = true;
    if (userCJ.uAdmin !== 0 || userCJ.uNum === userFiche.uNum) { persoSecu = false };
    let prodSecu = true;
    if (userCJ.uAdmin !== 0 || userCJ.uProducteur !== 0) { prodSecu = false };
    let globalSecu = false;
    if (userCJ.uAdmin === 0 && userFiche.uNum < 1) { globalSecu = true };

    const handleChangePass = (event) => {
        const { name, value } = event.target;
        setUserPass(oldUser => { return { ...userPass, [name]: value }; });
        setUserFiche(oldUser => { return { ...userFiche, uPass: value, uMsg: "" }; });
        event.preventDefault();
    };

    function checkEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    function verifierMotDePasse(motDePasse) {
        // Vérifier la longueur minimale
        if (motDePasse.length < 10) {
            return "Le mot de passe doit contenir au moins 10 caractères.";
        }

        // Vérifier la présence d'une majuscule
        if (!/[A-Z]/.test(motDePasse)) {
            return "Le mot de passe doit contenir au moins une majuscule.";
        }

        // Vérifier la présence d'une minuscule
        if (!/[a-z]/.test(motDePasse)) {
            return "Le mot de passe doit contenir au moins une minuscule.";
        }

        // Vérifier la présence d'un chiffre
        if (!/[0-9]/.test(motDePasse)) {
            return "Le mot de passe doit contenir au moins un chiffre.";
        }

        // Vérifier la présence d'un caractère non alphanumérique
        if (!/[^a-zA-Z0-9]/.test(motDePasse)) {
            return "Le mot de passe doit contenir au moins un caractère non alphanumérique.";
        }

        // Si toutes les vérifications sont passées
        return "";
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        let errMsg = "";
        if (userPass.verifPass.length > 0) {
            errMsg = verifierMotDePasse(userPass.verifPass)
        };
        if (errMsg.length < 1) {
            errMsg = verifierMotDePasse(userFiche.uPass)
        }
        // if ((userPass.verifPass.length>0 && userPass.verifPass.length<8) || userFiche.uPass.length<8) {
        //     errMsg="Le mot de passe doit avoir plus de 8 caracteres !";
        // };
        if (userPass.verifPass !== userPass.verifPass2) {
            errMsg = "Les deux mots de passe ne sont pas identiques !";
        };
        if (userFiche.uNom.length < 3) {
            errMsg = "Vous n'avez pas indiqué de nom !";
        };
        if (userFiche.uPrenom.length < 3) {
            errMsg = "Vous n'avez pas indiqué de prénom !";
        };
        if (!checkEmail(userFiche.uMail)) {
            errMsg = "L'adresse mail n'est pas valide !";
        };
        if (errMsg) {
            setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
        };
        fetch(`${URL_COURTJUS_BACK}/userverifexist/${userFiche.uMail}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                if (res != null) {
                    if (res[0].nb > 0 && res[0]._id.uNum !== userFiche.uNum) {
                        // si l'adresse existe déjà et que n'est pas la meme fiche utilisateur
                        errMsg = "Adresse mail déjà existante !"
                        setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
                    } else {
                        if (!errMsg) {
                            if (userFiche.uNum === 0) {
                                // Ajout d'un utilisateur
                                errMsg = "Utilisateur non identifié !"
                                setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
                            } else {
                                // Modification d'un utilisateur
                                dispatch(updateUserPW({ userFiche }))
                                errMsg = "Informations mises à jour !"
                                setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
                                setUserSave(oldUser => { return { ...userSave, saved: true }; });
                            }

                        }
                    }
                }
            });


    };



    return (
        <main className="container">
            <div className="main-down"></div>
            {/* {userMenu===true && <UserNav />} */}
            {/* {userMenu===true && <UserConnect />} */}
            {globalSecu === false &&
                <>
                    <section className="section-prods section-prods-form zone-tel-masque">
                        <form method="POST" id="formContact" encType="multipart/form-data" disabled={persoSecu} onSubmit={handleSubmit}>
                            <img src={`/img/pictures/${userFiche.uPhotoProfil}`} alt="la vue de l'adherent" className="float-prods" />
                            <article className="section-prods-fiche form-fiche">
                                <fieldset disabled={persoSecu}>
                                    <legend>infos contact <span className='span-light'>({userFiche.uNum})</span></legend>
                                    <p>{userFiche.uNom}</p>
                                    <p>{userFiche.uPrenom}</p>
                                    <p>{userFiche.uMail}</p>
                                    <p>{userFiche.uTel}</p>
                                </fieldset>

                            </article>
                            <article className="section-prods-infos form-fiche">
                                <fieldset disabled={persoSecu}>
                                    <p>&nbsp;</p>
                                    <p>
                                        <label htmlFor="verifPass">Mot de Passe</label> <input className="input-default" type="password" maxLength="18" name="verifPass" id="verifPass" value={userPass.verifPass} onChange={handleChangePass} />
                                        <br/><label htmlFor="verifPass2"> 2nde saisie</label> <input className="input-default" type="password" name="verifPass2" id="verifPass2" value={userPass.verifPass2} onChange={handleChangePass} />
                                    </p>
                                </fieldset>
                                <fieldset disabled={persoSecu}>
                                    <p>&nbsp;</p>
                                    {!userSave.saved &&
                                        <button id="fiche-sav" className='btn btn-primary'>Enregistrer</button>
                                    }
                                    <NavLink to={`/`} className="btn btn-secondary" title="Retour accueil">Retour</NavLink>
                                </fieldset>
                            </article>
                            <section className="nav-admin"><p className="section-prods-err">{userFiche.uMsg}</p></section>
                        </form>
                    </section>
                    <div className="main-down"></div>
                </>
            }
            {globalSecu &&
                <section className="section-prods"><p className="p-impact">Vous n'etes pas autorisé à acceder à ces informations</p></section>
            }
        </main>

    )
}

export default UserViewPW;